// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "calendar-" + chunkId + ".js?v=" + "6b7df5d21efab1eb02bb" + "";
};